<template>
  <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <!-- Start Banner -->
    <!-- <Banner
            :background="(info.image) ? info.image.url: ''"
            :title="(!pgLoading) ? $t('app.news') : ''"
            :subtitle="(!pgLoading) ? $t('app.news') : ''">
        </Banner> -->

    <div v-if="pgLoading" class="webkit-animation webkit-100-340">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="container">
            <div class="page-title-content">
              <h2><label class="webkit-animation webkit-250-75"></label></h2>
              <ul>
                <li class="webkit-pad5">
                  <label class="webkit-animation webkitpx-100-50"></label>
                </li>
                <li class="webkit-pad5">
                  <label class="webkit-animation webkitpx-100-50"></label>
                </li>
                <li class="webkit-pad5">
                  <label class="webkit-animation webkitpx-100-50"></label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!pgLoading"
      class="page-title-area"
      :class="locale == 'ar' ? 'rtl' : 'ltr'"
      :style="
        info.image
          ? 'background-image: url(' + info.image.url + ') !important'
          : ''
      "
    >
      <div class="d-table w-100 text-center">
        <div class="d-table-cell">
          <div class="container">
            <div class="page-title-content">
              <h1 class="text-white">{{ info.title }}</h1>
              <ul class="d-flex justify-content-center">
                <li>
                  <router-link
                    :to="{ name: 'home' }"
                    class="router-link-active text-white"
                  >
                    {{ $t("home.title") }} &nbsp;
                    <i class="far fa-chevron-left"></i>
                  </router-link>
                </li>
                <li class="text-white">&nbsp;&nbsp; {{ info.title }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Banner -->

    <section
      class="causes-section pt-70 pb-70"
      :class="locale == 'ar' ? 'rtl' : 'ltr'"
    >
      <div class="container">
        <div class="row mb-5 filter-country" style="margin-top: 20px">
          <div v-if="pgLoading" class="col-md-2">
            <div class="webkit-animation webkit-100-50"></div>
          </div>
          <div v-if="!pgLoading" class="col-md-3" style="margin-top: -30px">
            <div class="form-group">
              <div class="select-box">
                <select
                  class="form-control mb-5 mb-md-0"
                  style="height: 50px"
                  v-model="category_id"
                  @change="onCategory()"
                >
                  <option value="">
                    -- {{ $t("app.choose_category") }} --
                  </option>
                  <option
                    v-for="(cat, index) in categories"
                    :value="cat.id"
                    :key="index"
                  >
                    {{ cat.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <!-- <div v-if="pgLoading" class="col-md-3">
                  <div class="webkit-animation webkit-100-50"></div>
                </div>
                <div v-if="!pgLoading" class="col-md-3" style="margin-top: -30px">
                  <div class="form-group">
                    <div class="select-box">
                      <select class="form-control"
                          style="height: 50px" 
                          v-model="country_id"
                          @change="onCountry()">
                        <option value="">-- {{ $t('app.choose_country') }} -- </option>
                        <option v-for="(con, idx) in countries"
                            :key="idx"
                            :value="con.id">
                            {{ con.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div> -->

          <!-- <div v-if="pgLoading" class="col-md-3">
                  <div class="webkit-animation webkit-100-50"></div>
                </div>
                <div v-if="!pgLoading && country_id != ''" class="col-md-3" style="margin-top: -30px">
                  <div class="form-group">
                    <div class="select-box">
                      <select class="form-control"
                          style="height: 50px" 
                          v-model="city_id"
                          @change="onCities()">
                        <option value="">-- {{ $t('app.choose_city') }} -- </option>
                        <option v-for="(city, idx) in cities"
                            :key="idx"
                            :value="city.id">
                            {{ city.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div> -->

          <div v-if="pgLoading" class="col-md-2">
            <div class="webkit-animation webkit-100-50"></div>
          </div>
          <div v-if="!pgLoading" class="col-md-3" style="margin-top: -30px">
            <div class="form-group">
              <div class="select-box">
                <select
                  class="form-control"
                  style="height: 50px"
                  v-model="value_id"
                  @change="onValue()"
                >
                  <option value="">-- {{ $t("app.choose_value") }} --</option>
                  <option
                    v-for="(val, index) in values"
                    :value="val.id"
                    :key="index"
                  >
                    {{ val.amount }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div :class="country_id == '' ? 'col-md-3' : 'col-md-0'"></div>

          <div v-if="pgLoading" class="col-md-3 text-right">
            <div class="webkit-animation webkit-100-50"></div>
          </div>
          <div
            v-if="!pgLoading"
            class="col-md-3 text-right"
            style="margin-top: -30px"
          >
            <p class="line-height-30 mt-4 mt-md-0">
              {{ resultCount }} {{ $t("app.projects_count") }}
            </p>
          </div>
        </div>

        <div v-if="pgLoading" class="row justify-content-center">
          <div class="col-lg-4 col-md-6" v-for="(row, index) in 6" :key="index">
            <div class="single-causes">
              <div class="webkit-animation webkit-100-500"></div>
              <div class="causes-content webkit-animation webkit-100-235"></div>
            </div>
          </div>
        </div>

        <div
          v-if="!pgLoading"
          class="row g-5"
          :class="locale == 'ar' ? 'rtl' : 'ltr'"
        >
          <div v-if="resultCount == 0" class="row" style="width: 100%">
            <div class="col-md-4 col-sm-12"></div>
            <div
              class="box-nofound col-md-4 col-sm-12"
              style="text-align: center"
            >
              <img
                src="/assets/img/logo/min-logo.png"
                alt="no found"
                loading="lazy"
                style="margin-top: 30px; margin-bottom: 30px; width: 200px"
                class="img-notfound"
              />
            </div>
            <div class="col-md-4 col-sm-12"></div>
          </div>
          <div
            class="col-lg-4 col-md-6 mb-5"
            v-for="(row, index) in rows"
            :key="index"
          >
            <div
              class="single-causes"
              style="width: 100%; border-radius: 15px; overflow: hidden"
            >
              <img
                :src="
                  row.image ? row.image.url : '/assets/img/logo/min-logo.png'
                "
                :alt="row.title"
                style="min-height: 320px"
                class="w-100"
                loading="lazy"
              />
              <div
                class="causes-content"
                style="
                  width: 100%;
                  background-color: #eee;
                  padding: 10px 10px 20px;
                "
              >
                <h3 :class="locale == 'ar' ? 'text-right' : ''">
                  {{ row.title }}
                </h3>

                <!-- Progress -->
                <!--       <div class="box-progress-bar">
                                    <div class="progress">
                                        <div class="progress-bar" 
                                            role="progressbar" 
                                            :style="'width:'+row.percentage+'%'"
                                            :aria-valuenow="row.percentage" 
                                            aria-valuemin="0" 
                                            aria-valuemax="100">
                                        </div>
                                    </div>
                                </div> -->
                <!-- End Progress -->

                <span
                  style="width: 100%; display: block; margin-bottom: 10px"
                  :class="locale == 'ar' ? 'text-right' : ''"
                >
                  <!-- <i class="flaticon-clock"></i> -->
                  <!-- {{ $t('app.start_date') }}
                        {{ row.date }} -->
                  {{ row.value ? row.value.amount : "" }} دينار -
                  {{ $t("app.nominationValue") }}
                </span>
                <!-- <span style="width: 100%">
                        <i class="flaticon-pin"></i>
                        {{ (row.city) ? row.city.name : '' }}, {{ (row.country) ? row.country.name : '' }}
                      </span> -->
                <div
                  class="row"
                  style="margin-block: 5px; padding-inline: 15px"
                >
                  <!-- add to Cart :class="(row.has_cart) ? '' : 'hidden'-->
                  <!--  <a href="javascript:;"
                          :id="'btnSuccess_'+row.id"
                          class="causes-btn-one btn-size hidden"
                          style="background: #333">
                            <img alt="hear" 
                                src="/assets/img/icon/check.svg"
                                style="width: 30px;border:0">
                        </a> -->

                  <a
                    href="javascript:;"
                    :id="'btnLoading_' + row.id"
                    class="causes-btn-one btn-size hidden"
                  >
                    <div
                      class="loader loader-xs loader-center"
                      style="margin-top: -5px !important"
                    ></div>
                  </a>

                  <!-- <a href="javascript:;"
                          :id="'btnDonate_'+row.id"
                          @click="addToCart(row.id, row.has_donation)"
                          class="causes-btn-one btn-size"
                          :class="(row.has_cart) ? 'hidden' : ''">
                            <img alt="color" class="img-icon-1" src="/assets/img/icon/heart-color.svg">
                            <img alt="hear" class="img-icon-2" src="/assets/img/icon/heart.svg">
                            {{ $t('app.donate') }}
                        </a> -->
                  <!-- End add to Cart -->
                </div>
                <div class="case-btns d-flex justify-content-center">
                  <a
                    href="javascript:;"
                    data-toggle="modal"
                    data-target="#donateNomination"
                    class="causes-btn-one theme_btn theme_btn_bg"
                    @click="transformData(row)"
                  >
                    {{ $t("app.fill_form") }}
                  </a>
                  <a
                    :href="whatsAppNo + row.title"
                    target="_blank"
                    class="theme_btn theme_btn-whatsapp theme_btn_bg"
                    >{{ $t("app.contact") }}
                    <span :style="[locale == 'en' ? { left: 'auto' } : {}]"
                      ><i class="fab fa-whatsapp"></i
                    ></span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div class="col-lg-12 col-md-12">
            <div v-if="resultCount > itemsPerPage" class="pagination-area">
              <a
                v-if="prevPage != 0"
                @click="setPage(prevPage)"
                href="javascript:;"
                class="prev page-numbers"
              >
                <i class="flaticon-left"></i>
              </a>

              <a
                v-for="(pageNumber, index) in totalPages"
                :key="index"
                @click="pageNumber != currentPage ? setPage(pageNumber) : ''"
                :class="{
                  current: currentPage === pageNumber,
                  last:
                    pageNumber == totalPages - 1 &&
                    Math.abs(pageNumber - currentPage) > 3,
                  first:
                    pageNumber == 0 && Math.abs(pageNumber - currentPage) > 3,
                }"
                href="javascript:;"
                class="page-numbers"
              >
                {{ pageNumber }}
              </a>

              <a
                v-if="nextPage != 0"
                @click="setPage(nextPage)"
                href="javascript:;"
                class="next page-numbers"
              >
                <i class="flaticon-right"></i>
              </a>
            </div>
          </div>
          <!-- End Pagination -->
        </div>
      </div>
    </section>

    <Contacts></Contacts>

    <div
      class="modal fade donation-popup"
      :class="locale == 'ar' ? 'rtl' : 'ltr'"
      id="donateNomination"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body donate-form">
            <div class="row">
              <div class="col-md-12">
                <h4 class="widget-title">
                  {{ $t("app.fill_form") }}
                </h4>
                <div class="form-group text-center">
                  <h4>{{ row.project_name }}</h4>
                  <p>
                    {{ row.amount }} دينار - {{ $t("app.nominationValue") }}
                  </p>
                </div>
                <div class="form-group">
                  <label>{{ $t("cart.project_name") }} *</label>
                  <input
                    type="text"
                    v-model="row.name"
                    class="form-control"
                    required
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t("contact.mobile") }} *</label>
                  <input
                    type="text"
                    v-model="row.mobile"
                    class="form-control"
                    required
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t("contact.email") }}</label>
                  <input type="text" v-model="row.email" class="form-control" />
                </div>
                <div
                  class="form-check"
                  v-for="method in paymentMethods"
                  :key="method.PaymentMethodId"
                  style="margin-top: 10px"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    :id="'payment_' + method.PaymentMethodId"
                    name="payment_method"
                    :value="method.PaymentMethodId"
                    :checked="method.PaymentMethodId == 1"
                    @change="pamyentMethod(method.PaymentMethodId)"
                  />
                  <img
                    :alt="method.PaymentMethodEn"
                    class="img-check"
                    loading="lazy"
                    :src="method.ImageUrl"
                    :for="'payment_' + method.PaymentMethodId"
                    style="margin-top: -5px; margin-right: 20px; width: 35px"
                  />
                  <span class="payment-method-name" style="margin-right: 5px">
                    {{
                      $i18n.locale == "ar"
                        ? method.PaymentMethodAr
                        : method.PaymentMethodEn
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="col-2"></div>
            <div class="col-8">
              <div
                v-if="showLoading"
                class="btn btn-green btn-block"
                style="height: 40px"
              >
                <div
                  class="loader loader-xs loader-center"
                  style="margin-top: 1px"
                ></div>
              </div>
              <button
                v-if="!showLoading && !href"
                type="button"
                class="btn btn-green btn-block"
                @click="addToCart()"
                data-dismiss="modal"
              >
                {{ $t("app.donation_now") }}
              </button>
              <div v-if="!showLoading && href" class="text-center">
                <a
                  v-if="href"
                  :href="href"
                  target="_blank"
                  id="payment"
                  refs="payment"
                  class="default-btn btn-size"
                >
                  {{ $t("cart.go_to_payment") }}
                </a>
              </div>
            </div>
            <div class="col-2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//   import Contacts from '@/components/Contacts.vue';
import iziToast from "izitoast";
import { trackCheckout } from "@/helpers/pixel";
import { getPaymentMethods } from "@/data/paymentMethods";

export default {
  name: "List",
  components: {
    // Contacts,
  },
  data() {
    return {
      //
      auth: {
        access_token: "",
      },
      row: {
        name: "",
        email: "",
        mobile: "",
        project_name: "",
        project_nomination_id: "",
        amount: "",
        currency: "kwd",
        payment_method: 1,
      },
      locale: "ar",
      showLoading: false,
      pgLoading: true,
      info: "",
      rows: [],
      countries: [],
      categories: [],
      values: [],

      href: "",

      city_id: "",
      category_id: "",
      country_id: "",
      value_id: "",

      cityLoading: false,
      cities: [],

      currentPage: 1,
      itemsPerPage: 9,
      resultCount: 0,
      nextPage: 2,
      prevPage: 0,

      whatsAppNo: window.whatsAppNo,
      paymentMethods: [],
    };
  },
  computed: {
    totalPages: function () {
      return Math.ceil(this.resultCount / this.itemsPerPage);
    },
  },
  mounted() {
  },
  watch: {
    $route() {
      this.fetchData();
    },
  },
  created() {
    //
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    this.fetchData();
    this.fetchPaymentMethods();
  },
  methods: {
    //
    fetchData() {
      window.scrollTo(0, 0);
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/projectNomination",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
          category_id: this.category_id,
          country_id: this.country_id,
          city_id: this.city_id,
          value_id: this.value_id,
          search: this.$route.query.q,
          paginate: 9,
          page: this.currentPage,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
          this.categories = res.data.categories;
          //this.countries = res.data.countries;
          this.values = res.data.values;

          // info
          this.info = res.data.info;

          // pagination
          this.currentPage = res.data.paginate.current_page;
          //this.itemsPerPage = res.data.paginate.per_page;
          this.resultCount = res.data.paginate.total;
          this.nextPage = res.data.paginate.next_page;
          this.prevPage = res.data.paginate.prev_page;
        })
        .catch(() => {})
        .finally(() => {});
    },

    setPage: function (pageNumber) {
      this.currentPage = pageNumber;
      this.fetchData();
    },

    onCountry: function () {
      this.fetchCities();
      this.city_id = "";
      this.fetchData();
    },
    onCities: function () {
      this.fetchData();
    },

    fetchCities() {
      this.cityLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/cities",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          country_id: this.country_id,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.cityLoading = false;
          this.cities = res.data.rows;
        })
        .catch(() => {})
        .finally(() => {});
    },

    onCategory: function () {
      this.fetchData();
    },

    onValue: function () {
      this.fetchData();
    },

    addToCart() {
      this.showLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/projectNomination",
        method: "POST",
        data: {
          name: this.row.name,
          mobile: this.row.mobile,
          email: this.row.email,
          project_nomination_id: this.row.project_nomination_id,
          amount: this.row.amount,
          curreny: this.row.currency,
          payment_method: this.row.payment_method,
        },
        params: {},
      };
      this.$axios(options)
        .then((res) => {
          this.showLoading = false;

          trackCheckout({
            value: this.row.amount,
            currency: "KWD",
            content_ids: [this.row.project_nomination_id],
            content_name: this.row.project_name,
            content_type: "project_nomination",
            num_items: 1,
            payment_method: this.row.payment_method,
          });

          if (res.data.link) {
            window.open(res.data.link, "_blank");
            this.href = res.data.link;
          } else {
            iziToast.success({
              icon: "ti-check",
              title: "",
              message: "حدث خطأ, في عملية الدفع من فضلك حاول مرة آخري",
            });
          }
        })
        .catch((err) => {
          this.showLoading = false;
          iziToast.warning({
            icon: "ti-alert",
            title: "",
            message: err.response ? err.response.data.message : "" + err,
          });
        })
        .finally(() => {});
    },

    transformData(row) {
      this.row.project_name = row.title;
      this.row.project_nomination_id = row.id;
      this.row.amount = row.value ? row.value.amount : "";
    },

    pamyentMethod(id) {
      this.row.payment_method = id;
    },

    removeLocalStorage() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_image");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");
      localStorage.removeItem("user_id");
      localStorage.removeItem("email");
      localStorage.removeItem("id_number");
    },

    async fetchPaymentMethods() {
      this.paymentMethods = await getPaymentMethods();
    },
  },
};
</script>

<style scoped=""></style>
